import React, {useEffect, useRef} from 'react';
import WaitingScreenImage from './components/waiting_screen_image'
import WaitingScreenText from './components/waiting_screen_text'
import KavedoPlayer from './components/kavedo_player'
import BitmovinPlayer from './components/bitmovin_player'
import KavedoIvsPlayer from './components/kavedo_ivs_player'
import EmbeddedPlayer from './components/embedded_player.jsx'
//import AmazonIvsPlayer from './components/amazon_ivs_player.jsx'
import GenericUrlPlayer from './components/generic_url_player'
import VideoJsPlayer from './components/videojs_player'
import PolyPlayer from './components/poly_player'
import { useSelector, useDispatch } from 'react-redux'
import useInterval from '@use-it/interval'
import axios from 'axios'
import { setShowFraudWarning, setShowCookieWarning, setEntranceVideoInterval } from './actions'

import './video_player_stylesheet'
import BetOverlay from "../widgets/components/bet_overlay";


export default function VideoPlayer({videoRoom, streamKey, entranceUrl, ...props}) {
  let streamSource = null
  let playerType = null
  let playerConfig = null
  const entranceRepeatTime = useSelector(state => state.entranceVideoInterval)  * 1000
  //const entranceRepeatTime = (window.location.host == "localhost:3000" ? 5000 : (props.entranceRepeatTime ? props.entranceRepeatTime : (90 * 1000)))
  const showFraudWarning = useSelector(state => state.showFraudWarning)
  const showCookieWarning = useSelector(state => state.showCookieWarning)
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)
  const tagOwner = useSelector(state => state.tagOwner)
  const onLoadShowFraudWarning = useSelector(state => state.onLoadShowFraudWarning)
  const dispatch = useDispatch()
  const events = useSelector(state => state.events)
  const videoRoomEvent = events.find(event => event.id == videoRoom.event_id)
  //const videoRoomActiveEvent = events.find(event => event.id == videoRoom.event_id)
  const defaultEntranceUrl = useSelector(state => state.entranceUrl)

  if(props.entranceRepeatTime) {
    console.error("entranceRepeatTime is ignored & deprecated and serversettings are used")
  }

  const playerTypes = {
    embedded: EmbeddedPlayer,
    bitmovin: BitmovinPlayer,
    kavedo: KavedoPlayer,
    kavedo_ivs: KavedoIvsPlayer,
    amazon_ivs: VideoJsPlayer,//AmazonIvsPlayer,
    generic_url_player: GenericUrlPlayer,
    videojs: VideoJsPlayer,
    poly: PolyPlayer
  }

  const sendEntrance = () => {
    if(props.disableEntrances) {
      console.log("not sending entracen due to props.disableEntrances")
      return;
    }
    if(entranceUrl === undefined && defaultEntranceUrl === undefined) {
      alert("NO ENTRANCE URL DEFINED")
    }
    if(entranceUrl === undefined && defaultEntranceUrl !== undefined) {
      console.warn("Using default entrance url", defaultEntranceUrl)
    }
    if(defaultEntranceUrl == "ignore") {
      console.log("not sending entrance")
      return;
    }

    axios({
      url: (entranceUrl || defaultEntranceUrl).replace("@tag_owner_id@", tagOwner.id).replace("@video_room_id@", videoRoom.id),
      method: "post",
      timeout: entranceRepeatTime - 1000,
      streamKey: streamKey
    }).then(response => {
      console.log("sendEntrance", response.data)
      if(response.data.entranceVideoInterval && entranceRepeatTime != (response.data.entranceVideoInterval * 1000)) {
        console.log(response.data.entranceVideoInterval)
        dispatch(setEntranceVideoInterval(response.data.entranceVideoInterval))
      }
      if(response.data.error) {
        if(response.data.error_type == "nocookies") {
          dispatch(setShowCookieWarning(true))
        } else {
          dispatch(setShowFraudWarning(true))
        }
        console.error("entrance-push", response.data.error)
      } else {
        console.log("sendEntranceAndFraudCheckCall successfull", response.data) 
      }
    })
  }

  const sendEntranceAndFraudCheck = () => {
    if((entranceUrl || defaultEntranceUrl) && videoPlayerPlaying && (videoRoom.play_mode == "live" || videoRoom.play_mode == "vod")) {
      sendEntrance()
    }
  }

  useInterval(sendEntranceAndFraudCheck, entranceRepeatTime);
  useEffect(sendEntranceAndFraudCheck, [videoPlayerPlaying])

  // Initial entrance
  useEffect(sendEntrance, [])

  useEffect(() => { 
    console.log({entranceRepeatTime: entranceRepeatTime, playerType: playerType, streamSource: streamSource, track: props.track})
  }, [streamSource, playerType, props.track, entranceRepeatTime])

  if(videoRoom.play_mode == "waiting") {
    let img = videoRoomEvent?.images.video_waiting_screen_image?.xl?.url
    return <WaitingScreenImage imgSrc={img} children={props.children}/>
  }
  if(videoRoom.play_mode == "waiting_text") {
    return <WaitingScreenText videoRoom={videoRoom} videoRoomEvent={videoRoomEvent} text={videoRoomEvent.video_waiting_screen_text} children={props.children}/>
  }

  switch(videoRoom.play_mode) {
    case "live":
      // try {
      //   playerConfig = JSON.parse(videoRoom.livestream_player_config || "{}")
      //   console.log("Got player config", playerConfig)
      // } catch(ex) {
      //   console.error("Parsing player config went wrong", ex)
      // }
      streamSource = props.track == 2 && videoRoom.livestream_source_alternative && videoRoom.livestream_source_alternative != "" && videoRoom.livestream_source_alternative != "null" ? videoRoom.livestream_source_alternative : videoRoom.livestream_source
      playerType = videoRoom.livestream_player_type
      break;
    case "vod":
      // try {
      //   playerConfig = JSON.parse(videoRoom.vod_player_config || "{}")
      //   console.log("Got player config", playerConfig)
      // } catch(ex) {
      //   console.error("Parsing player config went wrong", ex)
      // }
      streamSource = props.track == 2 && videoRoom.vod_source_alternative && videoRoom.vod_source_alternative != "" && videoRoom.vod_source_alternative != "null" ? videoRoom.vod_source_alternative : videoRoom.vod_source
      playerType = videoRoom.vod_player_type
      break;
    default:
      console.error("Playmode not defined", playMode)
  }

  if((videoRoom.play_mode == "live" || videoRoom.play_mode == "vod") && !streamSource && !(videoRoom.livestream_player_config || videoRoom.vod_player_config)) {
    return <div className="alert alert-danger m-1">
            No video source configured
          </div>
  }

  if(showCookieWarning) {
    return (
      <div className="alert alert-danger m-1" id="alert_nocookie">
        <p className="text-center">
          <b>
            Cookies nicht aktiviert
          </b>
        </p>
        Ihr Browser erlaubt keine Cookies - bitte aktivieren Sie Cookies damit der Stream angezeigt werden kann.
      </div>
    )
  }

  if(showFraudWarning || onLoadShowFraudWarning) {
    return <div className="alert alert-danger m-1" id="alert">
      {props.fraudWarningHtml ? (
        <div dangerouslySetInnerHTML={{ __html: props.fraudWarningHtml}}/>
      ) : (
        <>
          <p className="text-center">
            <b>
              Stream wurde auf mehreren Geräten geöffnet.
            </b> 
          </p>

          <p className="text-center">
            Bitte schließen Sie die anderen Fenster und laden Sie die Seite erneut.
            <br/>
            Es kann bis zu 30 Sekunden dauern, bis der Stream wieder geöffnet werden kann.
          </p>
          
          <p className="text-center">
            Um den Stream erneut zu laden, klicken Sie bitte hier: {" "}
            <a onClick={() => { window.location = window.location}} href="#">
              <i className="fa fa-undo"></i>{" "}
              Stream neu laden
            </a>
          </p>
        </>
      )}
    </div>
  }

  const onFullscreenChange = (elementId) => {
    if (props.onFullscreenChange) {
      props.onFullscreenChange(elementId)
    }

    if ((videoRoom.livestream_player_type == "amazon_ivs" && videoRoom.play_mode == "live") || (videoRoom.vod_player_type == "amazon_ivs" && videoRoom.play_mode == "vod")) {
      const player = document.getElementById(elementId)
      if (player) {
        let customVoting = document.getElementById("video-room-bet-overlay")
        if (player != undefined && !player.contains(customVoting)) {
          player.appendChild(customVoting)
        }
      }
    }
  }

  const Player = playerTypes[playerType]
  return <>
    <div className="position-relative">
      <div data-videoroom-id={videoRoom.id}>
        <Player
          playerType={playerType}
          entranceRepeatTime={entranceRepeatTime}
          streamSource={streamSource}
          videoRoom={videoRoom}
          ontimeupdate={props.ontimeupdated}
          playerConfig={videoRoom.play_mode == "live" ? videoRoom.livestream_player_config : videoRoom.vod_player_config}
          {...props}
          onFullscreenChange={onFullscreenChange}/>
        {videoRoom.additional_layout_code &&
          <div dangerouslySetInnerHTML={{ __html: videoRoom.additional_layout_code}}/>
        }
      </div>
      <div id="video-room-bet-overlay" className={"d-none d-md-block"}>
        <BetOverlay videoRoom={videoRoom}/>
      </div>
    </div>
    <div id="video-room-bet-overlay-sm" className={"d-md-none"}>
      <BetOverlay videoRoom={videoRoom}/>
    </div>
  </>
}
